/* eslint-disable no-console */
import axios from "axios";
import { acquireToken } from "../auth/authUtils";

const baseUrl = process.env.REACT_APP_BASE_URL;
const endpoint = "config";

export const getConfigurations = async (region, isV2 = false) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.get(`${baseUrl}/configs/${region}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        isV2,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get configs API call failed:", error);
    throw error;
  }
};

export const getConfigurationById = async (id) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.get(`${baseUrl}/${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const addConfiguration = async (config) => {
  if (
    config?.platform !== "facebook" &&
    (baseUrl || "").includes("prospect.self-service.global.gcds.coke.com")
  ) {
    throw new Error(
      "Uploading partner configurations in Production has been temporarily disabled while governance improvements are being implemented."
    );
  }

  try {
    const accessToken = await acquireToken();
    const response = await axios.post(`${baseUrl}/${endpoint}`, config, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error("API call failed:", error);

    if (error?.response?.status === 409) {
      return {
        success: false,
        isConflict: true,
        message:
          error.response.data.message ||
          "Configuration already exists - please contact administrator",
      };
    }

    if (error?.response?.data) {
      const errorData = error.response.data;
      throw new Error(errorData.message || "An error occurred while saving the configuration");
    }

    throw error;
  }
};
